import React, { useContext } from 'react';

export const TOTReportingModuleConfigContext = React.createContext({});

export function useTOTReportingModuleConfigContext() {
  return useContext(TOTReportingModuleConfigContext);
}

